import { Chip } from '@assembly-js/design-system';
import clsx from 'clsx';
import { ComponentPropsWithoutRef } from 'react';

export interface ToggleChipOption {
  label: string;
  value: string;
  icon?: ComponentPropsWithoutRef<typeof Chip>['prefixIcon'];
}

export const ToggleChipGroup = ({
  options,
  value,
  onOptionClick,
  numColumns = 3,
}: {
  options: ToggleChipOption[];
  value: string | string[];
  onOptionClick: (value: string, label: string) => void;
  numColumns?: 2 | 3;
}) => (
  <div
    className={clsx(
      'grid grid-cols-1 gap-3',
      numColumns === 3 ? 'sm:grid-cols-3' : 'sm:grid-cols-2',
    )}
  >
    {options.map((option) => {
      const isSelected =
        typeof value === 'string'
          ? value === option.value
          : value.includes(option.value);

      return (
        <Chip
          variant={isSelected ? 'filled' : 'outlined'}
          size="lg"
          label={option.label}
          prefixIcon={option.icon}
          onClick={() => onOptionClick(option.value, option.label)}
          aria-pressed={isSelected}
          key={option.value}
        />
      );
    })}
  </div>
);
